export const domainFromUrl = (url: string) => {
  try {
    const urlObject = new URL(url);
    return urlObject.hostname;
  } catch {
    return url;
  }
}; 

/**
 *  Extracts a URL from a string of text.  If the text is a full URL, it is returned as is.  
 * If the text is a partial URL, it is returned as a full URL.  
 * If the text is not a URL, undefined is returned.
 * 
 * @param urlToTry some text that is a full or partial URL
 * @returns 
 */
export const extractUrlFromText = (
  urlToTry: string,
) => {
  let completeUrl = false;
  try {
    new URL(urlToTry);
    completeUrl = true;
  }
  catch (error) {
    // not a valid URL
  }

  let urlToStash;
  if (!completeUrl) {
    // see if it's a partial url  
    let partialUrl = false;
    try {
      new URL(`https://${urlToTry}`);
      partialUrl = true;
    }
    catch (error) {
      // not a valid URL
    }

    if (partialUrl) {
      urlToStash = `https://${urlToTry}`;
    }
  }
  else {
    urlToStash = urlToTry;
  }

  // strip off any utm parameters
  if (urlToStash) {
    const urlObject = new URL(urlToStash);
    urlObject.searchParams.delete('utm_source');
    urlObject.searchParams.delete('utm_medium');
    urlObject.searchParams.delete('utm_campaign');
    urlObject.searchParams.delete('utm_term');
    urlObject.searchParams.delete('utm_content');
    urlToStash = urlObject.toString();
  }

  return urlToStash;
};